/**
 * ImaginePay API
 * This API facilitates partner integration within the platform.
 *
 * The version of the OpenAPI document: 25_6_2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { IPAYGlobalDomainModelsCardTokensCardTokenSummary } from '../model/iPAYGlobalDomainModelsCardTokensCardTokenSummary';
// @ts-ignore
import { ImaginePayApiModelsAuditHistoryAuditTransactionHistoryResponse } from '../model/imaginePayApiModelsAuditHistoryAuditTransactionHistoryResponse';
// @ts-ignore
import { ImaginePayApiModelsMessageResponse } from '../model/imaginePayApiModelsMessageResponse';
// @ts-ignore
import { ImaginePayApiModelsPaymentPlanManipulatePaymentPlan } from '../model/imaginePayApiModelsPaymentPlanManipulatePaymentPlan';
// @ts-ignore
import { ImaginePayApiModelsPaymentPlanManipulatePaymentPlanResult } from '../model/imaginePayApiModelsPaymentPlanManipulatePaymentPlanResult';
// @ts-ignore
import { ImaginePayApiModelsPaymentPlanPaymentPlanLookUpResult } from '../model/imaginePayApiModelsPaymentPlanPaymentPlanLookUpResult';
// @ts-ignore
import { ImaginePayApiModelsPaymentPlanTruncatePaymentPlan } from '../model/imaginePayApiModelsPaymentPlanTruncatePaymentPlan';
// @ts-ignore
import { ImaginePayApiModelsPaymentPlanTruncatePaymentPlanResult } from '../model/imaginePayApiModelsPaymentPlanTruncatePaymentPlanResult';
// @ts-ignore
import { ImaginePayApiModelsPaymentRequestsExpirePaymentRequestResponse } from '../model/imaginePayApiModelsPaymentRequestsExpirePaymentRequestResponse';
// @ts-ignore
import { ImaginePayApiModelsPaymentRequestsPaymentRequestAccessUrl } from '../model/imaginePayApiModelsPaymentRequestsPaymentRequestAccessUrl';
// @ts-ignore
import { ImaginePayApiModelsPaymentRequestsVoidPayments } from '../model/imaginePayApiModelsPaymentRequestsVoidPayments';
// @ts-ignore
import { ImaginePayApiModelsPaymentRequestsVoidPaymentsResult } from '../model/imaginePayApiModelsPaymentRequestsVoidPaymentsResult';
// @ts-ignore
import { ImaginePayApiModelsTransactionLinkedTransactionRequest } from '../model/imaginePayApiModelsTransactionLinkedTransactionRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class PaymentRequestsService {
  protected basePath = 'https://devapi.imaginepay.com';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Post payment plan to cancel by payment request identifier
   * @param paymentRequestId A payment request identifier
   * @param authorization access token
   * @param request A request to manipulate a payment plan
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public paymentRequestsCancelPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanManipulatePaymentPlan,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<ImaginePayApiModelsPaymentPlanManipulatePaymentPlanResult>;
  public paymentRequestsCancelPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanManipulatePaymentPlan,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpResponse<ImaginePayApiModelsPaymentPlanManipulatePaymentPlanResult>>;
  public paymentRequestsCancelPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanManipulatePaymentPlan,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpEvent<ImaginePayApiModelsPaymentPlanManipulatePaymentPlanResult>>;
  public paymentRequestsCancelPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanManipulatePaymentPlan,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<any> {
    if (paymentRequestId === null || paymentRequestId === undefined) {
      throw new Error(
        'Required parameter paymentRequestId was null or undefined when calling paymentRequestsCancelPaymentPlanByPaymentRequestId.'
      );
    }
    if (authorization === null || authorization === undefined) {
      throw new Error(
        'Required parameter authorization was null or undefined when calling paymentRequestsCancelPaymentPlanByPaymentRequestId.'
      );
    }
    if (request === null || request === undefined) {
      throw new Error(
        'Required parameter request was null or undefined when calling paymentRequestsCancelPaymentPlanByPaymentRequestId.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      localVarHeaders = localVarHeaders.set('Authorization', String(authorization));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json', 'text/json', 'application/xml', 'text/xml'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'text/json', 'application/x-www-form-urlencoded'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<ImaginePayApiModelsPaymentPlanManipulatePaymentPlanResult>(
      `${this.configuration.basePath}/paymentrequests/${encodeURIComponent(
        String(paymentRequestId)
      )}/paymentplan/cancel`,
      request,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Expires a Payment Request
   * @param paymentRequestId A payment request identifier
   * @param authorization access token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public paymentRequestsExpirePaymentRequestByRequestID(
    paymentRequestId: number,
    authorization: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<ImaginePayApiModelsPaymentRequestsExpirePaymentRequestResponse>;
  public paymentRequestsExpirePaymentRequestByRequestID(
    paymentRequestId: number,
    authorization: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpResponse<ImaginePayApiModelsPaymentRequestsExpirePaymentRequestResponse>>;
  public paymentRequestsExpirePaymentRequestByRequestID(
    paymentRequestId: number,
    authorization: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpEvent<ImaginePayApiModelsPaymentRequestsExpirePaymentRequestResponse>>;
  public paymentRequestsExpirePaymentRequestByRequestID(
    paymentRequestId: number,
    authorization: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<any> {
    if (paymentRequestId === null || paymentRequestId === undefined) {
      throw new Error(
        'Required parameter paymentRequestId was null or undefined when calling paymentRequestsExpirePaymentRequestByRequestID.'
      );
    }
    if (authorization === null || authorization === undefined) {
      throw new Error(
        'Required parameter authorization was null or undefined when calling paymentRequestsExpirePaymentRequestByRequestID.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      localVarHeaders = localVarHeaders.set('Authorization', String(authorization));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json', 'text/json', 'application/xml', 'text/xml'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.put<ImaginePayApiModelsPaymentRequestsExpirePaymentRequestResponse>(
      `${this.configuration.basePath}/paymentrequests/${encodeURIComponent(String(paymentRequestId))}/expire`,
      null,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Payment Request Access Urls
   * @param paymentRequestId A payment request identifier
   * @param authorization access token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public paymentRequestsGetAccessUrls(
    paymentRequestId: number,
    authorization: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<ImaginePayApiModelsPaymentRequestsPaymentRequestAccessUrl>;
  public paymentRequestsGetAccessUrls(
    paymentRequestId: number,
    authorization: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpResponse<ImaginePayApiModelsPaymentRequestsPaymentRequestAccessUrl>>;
  public paymentRequestsGetAccessUrls(
    paymentRequestId: number,
    authorization: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpEvent<ImaginePayApiModelsPaymentRequestsPaymentRequestAccessUrl>>;
  public paymentRequestsGetAccessUrls(
    paymentRequestId: number,
    authorization: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<any> {
    if (paymentRequestId === null || paymentRequestId === undefined) {
      throw new Error(
        'Required parameter paymentRequestId was null or undefined when calling paymentRequestsGetAccessUrls.'
      );
    }
    if (authorization === null || authorization === undefined) {
      throw new Error(
        'Required parameter authorization was null or undefined when calling paymentRequestsGetAccessUrls.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      localVarHeaders = localVarHeaders.set('Authorization', String(authorization));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json', 'text/json', 'application/xml', 'text/xml'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<ImaginePayApiModelsPaymentRequestsPaymentRequestAccessUrl>(
      `${this.configuration.basePath}/paymentrequests/${encodeURIComponent(String(paymentRequestId))}/access`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Most Recent Transaction Details for Payment Request
   * @param paymentRequestId A payment request identifier
   * @param authorization access token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public paymentRequestsGetMostRecentTransactionByRequest(
    paymentRequestId: number,
    authorization: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<ImaginePayApiModelsAuditHistoryAuditTransactionHistoryResponse>;
  public paymentRequestsGetMostRecentTransactionByRequest(
    paymentRequestId: number,
    authorization: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpResponse<ImaginePayApiModelsAuditHistoryAuditTransactionHistoryResponse>>;
  public paymentRequestsGetMostRecentTransactionByRequest(
    paymentRequestId: number,
    authorization: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpEvent<ImaginePayApiModelsAuditHistoryAuditTransactionHistoryResponse>>;
  public paymentRequestsGetMostRecentTransactionByRequest(
    paymentRequestId: number,
    authorization: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<any> {
    if (paymentRequestId === null || paymentRequestId === undefined) {
      throw new Error(
        'Required parameter paymentRequestId was null or undefined when calling paymentRequestsGetMostRecentTransactionByRequest.'
      );
    }
    if (authorization === null || authorization === undefined) {
      throw new Error(
        'Required parameter authorization was null or undefined when calling paymentRequestsGetMostRecentTransactionByRequest.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      localVarHeaders = localVarHeaders.set('Authorization', String(authorization));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json', 'text/json', 'application/xml', 'text/xml'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<ImaginePayApiModelsAuditHistoryAuditTransactionHistoryResponse>(
      `${this.configuration.basePath}/paymentrequests/${encodeURIComponent(String(paymentRequestId))}/transaction`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Post payment plan to place on hold by payment request identifier
   * @param paymentRequestId A payment request identifier
   * @param authorization access token
   * @param request A request to manipulate a payment plan
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public paymentRequestsHoldPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanManipulatePaymentPlan,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<ImaginePayApiModelsPaymentPlanManipulatePaymentPlanResult>;
  public paymentRequestsHoldPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanManipulatePaymentPlan,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpResponse<ImaginePayApiModelsPaymentPlanManipulatePaymentPlanResult>>;
  public paymentRequestsHoldPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanManipulatePaymentPlan,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpEvent<ImaginePayApiModelsPaymentPlanManipulatePaymentPlanResult>>;
  public paymentRequestsHoldPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanManipulatePaymentPlan,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<any> {
    if (paymentRequestId === null || paymentRequestId === undefined) {
      throw new Error(
        'Required parameter paymentRequestId was null or undefined when calling paymentRequestsHoldPaymentPlanByPaymentRequestId.'
      );
    }
    if (authorization === null || authorization === undefined) {
      throw new Error(
        'Required parameter authorization was null or undefined when calling paymentRequestsHoldPaymentPlanByPaymentRequestId.'
      );
    }
    if (request === null || request === undefined) {
      throw new Error(
        'Required parameter request was null or undefined when calling paymentRequestsHoldPaymentPlanByPaymentRequestId.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      localVarHeaders = localVarHeaders.set('Authorization', String(authorization));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json', 'text/json', 'application/xml', 'text/xml'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'text/json', 'application/x-www-form-urlencoded'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<ImaginePayApiModelsPaymentPlanManipulatePaymentPlanResult>(
      `${this.configuration.basePath}/paymentrequests/${encodeURIComponent(String(paymentRequestId))}/paymentplan/hold`,
      request,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get payment plan by payment request identifier
   * @param paymentRequestId A payment request identifier
   * @param authorization access token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public paymentRequestsLookUpPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<ImaginePayApiModelsPaymentPlanPaymentPlanLookUpResult>;
  public paymentRequestsLookUpPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpResponse<ImaginePayApiModelsPaymentPlanPaymentPlanLookUpResult>>;
  public paymentRequestsLookUpPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpEvent<ImaginePayApiModelsPaymentPlanPaymentPlanLookUpResult>>;
  public paymentRequestsLookUpPaymentPlanByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<any> {
    if (paymentRequestId === null || paymentRequestId === undefined) {
      throw new Error(
        'Required parameter paymentRequestId was null or undefined when calling paymentRequestsLookUpPaymentPlanByPaymentRequestId.'
      );
    }
    if (authorization === null || authorization === undefined) {
      throw new Error(
        'Required parameter authorization was null or undefined when calling paymentRequestsLookUpPaymentPlanByPaymentRequestId.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      localVarHeaders = localVarHeaders.set('Authorization', String(authorization));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json', 'text/json', 'application/xml', 'text/xml'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<ImaginePayApiModelsPaymentPlanPaymentPlanLookUpResult>(
      `${this.configuration.basePath}/paymentrequests/${encodeURIComponent(String(paymentRequestId))}/paymentplan`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param paymentRequestId
   * @param authorization access token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public paymentRequestsTokens(
    paymentRequestId: number,
    authorization: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<Array<IPAYGlobalDomainModelsCardTokensCardTokenSummary>>;
  public paymentRequestsTokens(
    paymentRequestId: number,
    authorization: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpResponse<Array<IPAYGlobalDomainModelsCardTokensCardTokenSummary>>>;
  public paymentRequestsTokens(
    paymentRequestId: number,
    authorization: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpEvent<Array<IPAYGlobalDomainModelsCardTokensCardTokenSummary>>>;
  public paymentRequestsTokens(
    paymentRequestId: number,
    authorization: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<any> {
    if (paymentRequestId === null || paymentRequestId === undefined) {
      throw new Error('Required parameter paymentRequestId was null or undefined when calling paymentRequestsTokens.');
    }
    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling paymentRequestsTokens.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      localVarHeaders = localVarHeaders.set('Authorization', String(authorization));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json', 'text/json', 'application/xml', 'text/xml'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<IPAYGlobalDomainModelsCardTokensCardTokenSummary>>(
      `${this.configuration.basePath}/paymentrequests/${encodeURIComponent(String(paymentRequestId))}/tokens`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Process a payment for the matching balance
   * @param paymentRequestId
   * @param authorization access token
   * @param linkedTransactionRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public paymentRequestsTransaction(
    paymentRequestId: number,
    authorization: string,
    linkedTransactionRequest: ImaginePayApiModelsTransactionLinkedTransactionRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<ImaginePayApiModelsAuditHistoryAuditTransactionHistoryResponse>;
  public paymentRequestsTransaction(
    paymentRequestId: number,
    authorization: string,
    linkedTransactionRequest: ImaginePayApiModelsTransactionLinkedTransactionRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpResponse<ImaginePayApiModelsAuditHistoryAuditTransactionHistoryResponse>>;
  public paymentRequestsTransaction(
    paymentRequestId: number,
    authorization: string,
    linkedTransactionRequest: ImaginePayApiModelsTransactionLinkedTransactionRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpEvent<ImaginePayApiModelsAuditHistoryAuditTransactionHistoryResponse>>;
  public paymentRequestsTransaction(
    paymentRequestId: number,
    authorization: string,
    linkedTransactionRequest: ImaginePayApiModelsTransactionLinkedTransactionRequest,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<any> {
    if (paymentRequestId === null || paymentRequestId === undefined) {
      throw new Error(
        'Required parameter paymentRequestId was null or undefined when calling paymentRequestsTransaction.'
      );
    }
    if (authorization === null || authorization === undefined) {
      throw new Error(
        'Required parameter authorization was null or undefined when calling paymentRequestsTransaction.'
      );
    }
    if (linkedTransactionRequest === null || linkedTransactionRequest === undefined) {
      throw new Error(
        'Required parameter linkedTransactionRequest was null or undefined when calling paymentRequestsTransaction.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      localVarHeaders = localVarHeaders.set('Authorization', String(authorization));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json', 'text/json', 'application/xml', 'text/xml'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml',
      'application/x-www-form-urlencoded'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<ImaginePayApiModelsAuditHistoryAuditTransactionHistoryResponse>(
      `${this.configuration.basePath}/paymentrequests/${encodeURIComponent(String(paymentRequestId))}/transaction`,
      linkedTransactionRequest,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Post payment plan to truncate by payment request identifier
   * @param paymentRequestId
   * @param authorization access token
   * @param request
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public paymentRequestsTruncatePaymentPlanByPlanId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanTruncatePaymentPlan,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<ImaginePayApiModelsPaymentPlanTruncatePaymentPlanResult>;
  public paymentRequestsTruncatePaymentPlanByPlanId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanTruncatePaymentPlan,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpResponse<ImaginePayApiModelsPaymentPlanTruncatePaymentPlanResult>>;
  public paymentRequestsTruncatePaymentPlanByPlanId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanTruncatePaymentPlan,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpEvent<ImaginePayApiModelsPaymentPlanTruncatePaymentPlanResult>>;
  public paymentRequestsTruncatePaymentPlanByPlanId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentPlanTruncatePaymentPlan,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<any> {
    if (paymentRequestId === null || paymentRequestId === undefined) {
      throw new Error(
        'Required parameter paymentRequestId was null or undefined when calling paymentRequestsTruncatePaymentPlanByPlanId.'
      );
    }
    if (authorization === null || authorization === undefined) {
      throw new Error(
        'Required parameter authorization was null or undefined when calling paymentRequestsTruncatePaymentPlanByPlanId.'
      );
    }
    if (request === null || request === undefined) {
      throw new Error(
        'Required parameter request was null or undefined when calling paymentRequestsTruncatePaymentPlanByPlanId.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      localVarHeaders = localVarHeaders.set('Authorization', String(authorization));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json', 'text/json', 'application/xml', 'text/xml'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'text/json', 'application/x-www-form-urlencoded'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<ImaginePayApiModelsPaymentPlanTruncatePaymentPlanResult>(
      `${this.configuration.basePath}/paymentrequests/${encodeURIComponent(
        String(paymentRequestId)
      )}/paymentplan/truncate`,
      request,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Void payments by payment request identifier
   * @param paymentRequestId A payment request identifier
   * @param authorization access token
   * @param request A request to manipulate a payment plan
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public paymentRequestsVoidPaymentsByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentRequestsVoidPayments,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<ImaginePayApiModelsPaymentRequestsVoidPaymentsResult>;
  public paymentRequestsVoidPaymentsByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentRequestsVoidPayments,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpResponse<ImaginePayApiModelsPaymentRequestsVoidPaymentsResult>>;
  public paymentRequestsVoidPaymentsByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentRequestsVoidPayments,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<HttpEvent<ImaginePayApiModelsPaymentRequestsVoidPaymentsResult>>;
  public paymentRequestsVoidPaymentsByPaymentRequestId(
    paymentRequestId: number,
    authorization: string,
    request: ImaginePayApiModelsPaymentRequestsVoidPayments,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json' | 'text/json' | 'application/xml' | 'text/xml';
      context?: HttpContext;
    }
  ): Observable<any> {
    if (paymentRequestId === null || paymentRequestId === undefined) {
      throw new Error(
        'Required parameter paymentRequestId was null or undefined when calling paymentRequestsVoidPaymentsByPaymentRequestId.'
      );
    }
    if (authorization === null || authorization === undefined) {
      throw new Error(
        'Required parameter authorization was null or undefined when calling paymentRequestsVoidPaymentsByPaymentRequestId.'
      );
    }
    if (request === null || request === undefined) {
      throw new Error(
        'Required parameter request was null or undefined when calling paymentRequestsVoidPaymentsByPaymentRequestId.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      localVarHeaders = localVarHeaders.set('Authorization', String(authorization));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json', 'text/json', 'application/xml', 'text/xml'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'text/json', 'application/x-www-form-urlencoded'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.put<ImaginePayApiModelsPaymentRequestsVoidPaymentsResult>(
      `${this.configuration.basePath}/paymentrequests/${encodeURIComponent(String(paymentRequestId))}/void-payments`,
      request,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}
